import {
  takeEvery, call, put, fork
} from 'redux-saga/effects';
import * as actions from '../actions/warehouseProductActions';
import * as api from '../api/warehouseProduct';

function* getWarehouseProduct(params) {
  try {
    const result = yield call(api.getWarehouseProduct, params);
    yield put(actions.getWarehouseProductSuccess(result.data.length === 0 ? [] : result.data));
  } catch (error) {
 
  }
}

function* watchGetWarehouseProductRequest() {
  yield takeEvery(actions.Types.GET_WAREHOUSE_PRODUCT_REQUEST, getWarehouseProduct);
}

const warehouseProductSagas = [fork(watchGetWarehouseProductRequest)];

export default warehouseProductSagas;
